// YARN
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
  GridRowId,
  GridRowsProp,
  GridValidRowModel,
} from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { useTranslation } from 'react-i18next';
// THEMES
import { StyledTooltip } from './CustomGenericDataGridUtils';

const useDataGridCommonListActions = (
  rows: GridRowsProp,
  setModal: React.Dispatch<React.SetStateAction<boolean>>,
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>,
  setEditData: React.Dispatch<React.SetStateAction<GridValidRowModel | null | undefined>>,
  setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>,
  setActionId: React.Dispatch<React.SetStateAction<GridRowId | null>>,
  options: {
    fromTechnicianSector?: number;
    handleRemoveTechnicianFromSector?: (id: GridRowId) => Promise<void>;
    typeProcedure?: string;
  } = {},
) => {
  const { t } = useTranslation();
  const handleEditDialogOpen = (id: GridRowId): void => {
    setEditData(rows.find((row) => row.id === id));
    setIsEdit(true);
    setModal(true);
  };
  const handleDeleteDialogOpen = (id: GridRowId): void => {
    setActionId(id);
    setOpenDeleteDialog(true);
  };

  const handleRemoveTechnician = (id: GridRowId): void => {
    options?.handleRemoveTechnicianFromSector && options?.handleRemoveTechnicianFromSector(id);
  };

  const getActions = (
    id: GridRowId,
  ): React.ReactElement<GridActionsCellItemProps, string | React.JSXElementConstructor<any>>[] => {
    return [
      <div>
        <StyledTooltip placement="top" title={t('action.edit')}>
          <GridActionsCellItem
            icon={<EditIcon sx={{ paddingLeft: '2px !important' }} />}
            label={t('action.edit')}
            className="textPrimary"
            onClick={() => handleEditDialogOpen(id)}
            color="inherit"
          />
        </StyledTooltip>
        {options?.typeProcedure !== 'backward' && (
          <StyledTooltip placement="top" title={t('common.delete')}>
            <GridActionsCellItem
              icon={<DeleteIcon sx={{ paddingLeft: '2px !important' }} />}
              label={t('common.delete')}
              onClick={() => handleDeleteDialogOpen(id)}
              color="inherit"
            />
          </StyledTooltip>
        )}
        {options?.fromTechnicianSector !== 0 && options?.handleRemoveTechnicianFromSector && (
          <StyledTooltip placement="top" title={t('action.removeFromSector')}>
            <GridActionsCellItem
              icon={<PersonRemoveIcon sx={{ paddingLeft: '2px !important' }} />}
              label={t('action.removeFromSector')}
              onClick={() => handleRemoveTechnician(id)}
              color="inherit"
            />
          </StyledTooltip>
        )}
      </div>,
    ];
  };

  return {
    getActions,
  };
};

export default useDataGridCommonListActions;
